import React, { useEffect, useRef, useState } from 'react';
import '../../../styles/mainContents.css'
import { fetchOrdernosPrintPicktickets, PrintOrder, fetchInventory, fetchCustomers, fetchTransfers, fetchOrders, fetchOrdernoDetail, fetchSubmitOrdernoDetail, addLineOrdernoDetail, deleteRowLineOrdernoDetail } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { Tooltip, IconButton } from '@mui/material';
import { createTheme, ThemeProvider  } from '@mui/material/styles'
import { Print  } from '@mui/icons-material'
import { superSearch } from '@codewell/super-search';
import EmptyMuiDataTable from '../../layout/EmptyMuiDataTable';
import fmplogo from '../../../assets/FMP-Icon.png';
import moment from "moment";
import ReactToPrint, { useReactToPrint }  from 'react-to-print';

function Orders(props) {

  const dispatch = useDispatch();
  // const history = useHistory();
  // const handleOnClick = () => history.push('localhost:3000/login');

  const { ordersPrintState, fetch_OrdernosPrintPicktickets, fetch_landingPageStates, dispatch_deleteRowLineOrdernoDetail, dispatch_addLineOrdernoDetail, dispatch_Print, corePickupState, fetch_submitOrdernoDetail, orderServerResponseState, orderState, orderDetailState, orderDetailHeaderState, authreducerState, fetch_orders, fetch_ordernoDetail } = props;

  let [rowsOrdersIndexState, setRowsOrdersIndexState] = useState([])
  // let [selectedRowsOrdersState, setSelectedRowsOrdersState] = useState({})
  let [selectedOrdernosState, setSelectedOrdernosState] = useState([])

  const [printBtnClickedState, setPrintBtnClickedState] = useState(false)

  const componentRef = useRef();

  useEffect( () => {
    fetch_orders(authreducerState.user) 
  }, []);

  let [corePickupAvailableChecked, setCorePickupAvailableChecked] = React.useState(true);
  useEffect( () => {
    orderServerResponseState !== undefined && 
                      Object.keys(orderServerResponseState).length > 0 &&
                        orderServerResponseState['SUCCESSFUL_UPDATES'] !== '' ?
                        setCorePickupAvailableChecked(true) : setCorePickupAvailableChecked(corePickupAvailableChecked)
  }, [orderServerResponseState, corePickupAvailableChecked]);

  const columnsOrders = [
    {
      name: "ORDERNO",
      label: "Orderno",
      options: {
        filter: false,
        sort: true, 
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}),             
      },
    },
    {
      name: "ORDERED",
      label: "Order Date",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"45px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
          fontWeight: "bolder",
          textAlign: "center",
        }}),
        customBodyRenderLite: (dataIndex, rowIndex) => { 

          let ordered = orderState[dataIndex]['ORDERED'] !== '' ? moment(new Date(orderState[dataIndex]['ORDERED'])).format('MM/DD/YYYY') : ''
          let orderHighlightExceptionColumnCN = '';
          if(ordered !== '' && moment(new Date(orderState[dataIndex]['HIGHLIGHT_EXCEPTION_DATE'])) > moment(new Date(orderState[dataIndex]['ORDERED'])) ) {
            orderHighlightExceptionColumnCN = 'orderHighlightExceptionColumnCN'
          }

          return (
            <span>  
              <div className={ orderHighlightExceptionColumnCN}>              
                {ordered}
              </div>                                                                                              
            </span>
          ) 
  
        }         
      },
    },
    // {
    //   name: "HIGHLIGHT_EXCEPTION_DATE",
    //   label: "HIGHLIGHT_EXCEPTION_DATE",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     setCellHeaderProps: () => ( {style: {
    //       maxWidth:"85px", 
    //       wordWrap: "normal", 
    //       padding: "14px 4px 14px 16px",
    //     }}),         
    //     setCellProps: () => ( {style: {
    //       maxWidth:"55px", 
    //       wordWrap: "break-word",
    //       padding: "14px 4px 14px 16px",
    //     }}),
    //     customBodyRenderLite: (dataIndex, rowIndex) => { 

    //       let ordered = moment(new Date(orderState[dataIndex]['ORDERED'])).format('MM/DD/YYYY')
    //       let orderHighlightExceptionColumnCN = '';
    //       if(orderState[dataIndex]['HIGHLIGHT_EXCEPTION_DATE'] > ordered) {
    //         orderHighlightExceptionColumnCN = 'orderHighlightExceptionColumnCN'
    //       }


    //       console.log(orderState[dataIndex]['HIGHLIGHT_EXCEPTION_DATE'] , ordered, orderState[dataIndex]['HIGHLIGHT_EXCEPTION_DATE'] > orderState[dataIndex]['ORDERED'] )
    //       return (
    //         <span>  


    //           <div className={ orderHighlightExceptionColumnCN}>              
    //             {orderState[dataIndex]['HIGHLIGHT_EXCEPTION_DATE']}
    //           </div>                                                                                              
    //         </span>
    //       ) 
  
    //     }  

    //   },
    // },    
    {
      name: "CUSTNO",
      label: "Cust#",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),
      },
    },
    {
      name: "CUSTNAME",
      label: "Cust name",
      options: {
        filter: false,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "2px 4px 0px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"125px", 
          wordWrap: "break-word",
          padding: "14px 10px 14px 16px",         
          fontSize: ".875em", 
        }}),
      },
    },
    {
      name: "SHIP_TO_CITY",
      label: "Ship To City",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"95px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),
      },
    },
    {
      name: "SHIP_TO_STATE",
      label: "Ship To State",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"95px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"30px", 
          wordWrap: "normal",
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),
      },
    },
    {
      name: "CUST_PO",
      label: "Cust PO",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"100px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }} 
        ),
      }
    },                       
  ]

  const optionsOrders = {
    filterType: "checkbox",
    selectableRows: "multiple",
    selectableRowsHeader: false,
    rowsSelected: rowsOrdersIndexState, 
    onRowSelectionChange: (rowsSelectedData, allRows, rowsSelected) => {
      console.log('onRowSelectionChange:', rowsSelectedData, allRows, rowsSelected);
      let ordersSelectedList = allRows.map((item,index)=>{ return orderState[item.dataIndex]})
      let ordernoSelectedList = ordersSelectedList.map((item,index)=>{
          return item.ORDERNO
      })      
      console.log('onRowSelectionChange invnoSelectedList:', JSON.stringify(ordernoSelectedList));

      setRowsOrdersIndexState(rowsSelected)
      setSelectedOrdernosState(ordernoSelectedList)
      // console.log('onRowSelectionChange rowsDataIndexState: ' + JSON.stringify(rowsDataIndexState));
    },   
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <>
        <ClearSelectedCheckboxButton selectedRows={selectedRows}/>
        <PrintOrdersPickticketButton 
          selectedRows={selectedRows}   
        />
      </>
    ),            
    responsive: "standard",
    fixedHeader: true,
    download:true,
    //tableId: 'ordersTblId',
    search: true,
    searchOpen: true,
    //searchAlwaysOpen: true,
    searchPlaceholder: 'SEARCH ORDERS',
    onRowClick: (rowData, rowMeta) => {
      fetch_ordernoDetail(authreducerState.user,rowData[0]);
    },  

    searchProps: {
      autoFocus: true,
      onKeyUp:(e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {          
          var rowsCounter = 0;
          var orderno = null;
          orderState.reduce( (previousValue, currentValue, currentIndex, array) => {          
            if(rowsCounter > 1){
              return null;
            }

            if(superSearch()(e.target.value, {...currentValue}).numberOfMatches>0){
              orderno = currentValue['ORDERNO']
              rowsCounter++
            }

            return rowsCounter;
          }, 0)

          if(rowsCounter === 1){
            fetch_ordernoDetail(authreducerState.user,orderno);
          }
        }
      }
    }, 

    rowsPerPage: 10,   
  };
  
  const columnsOptions_ordernoDetail = (colName='', inputType='number',filterEnabled=true) => {
    var options = {};
    let maxValue = 1000;
    
    options = {
      filter: filterEnabled,
      sort: true,
      fixedHeader: true,
      download:false,
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          top: '0px',
          zIndex: 101,            
        }
      }),  
      customBodyRenderLite: (dataIndex, rowIndex) => {
        let newOrdernoDetailState = [...orderDetailState]   

        if(orderServerResponseState !== undefined && 
          Object.keys(orderServerResponseState).length > 0 &&
            orderServerResponseState['SUCCESSFUL_UPDATES'] !== '') 
        {

          //UNNEEDED AS WILL GO TO LANDING PAGE STATES AFTER SUCCESSFUL SUBMIT
          return (
            <span>  
              <React.Fragment>              
              {newOrdernoDetailState[dataIndex][colName]}  
              </React.Fragment>                                                                                  
            </span>
          )  
        }
        else
        {
          if(newOrdernoDetailState[dataIndex]['QTY_TYPE'] === 'TO_INSERT' ){
          
            if(colName === 'LINE'){
              return (
                <React.Fragment>            
                  {authreducerState.user.role_name === undefined || 
                    (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ||
                    (newOrdernoDetailState[dataIndex]['LINE'] === 'C') ? 
                    ( 
                      <React.Fragment></React.Fragment> 
                    ) 
                    : 
                    (
                      <React.Fragment>                  
                        <input 
                          id={'iOrderDetailInputIndex' + dataIndex + '-' + rowIndex} 
                          type={inputType} 
                          name={'nOrderDetailInputIndex' + dataIndex + '-' + rowIndex}
                          key={dataIndex + '-' + rowIndex + '-' + newOrdernoDetailState[dataIndex]['LINENO'] + '-' + newOrdernoDetailState[dataIndex]['LINE'] + '-' + newOrdernoDetailState[dataIndex]['PARTNO'] + '-' + newOrdernoDetailState[dataIndex]['USER_INPUT_QTY']}
                          defaultValue={newOrdernoDetailState[dataIndex][colName] === null ? '' : newOrdernoDetailState[dataIndex][colName]}
                          maxLength="3"
                          onChange={(e) => {
                              newOrdernoDetailState[dataIndex][colName] = e.target.value.trim()
                              console.log('Orders newOrdernoDetailState[dataIndex][colName]:' + JSON.stringify(newOrdernoDetailState[dataIndex][colName]))                  
                            }
                          }                  
                        />                                                                           
                        
                      </React.Fragment>
                    )
                  }
                </React.Fragment> 
              )          
            } 
            else if(colName === 'PARTNO'){
              return (
                <span>              
                  {authreducerState.user.role_name === undefined || 
                    (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ||
                    (newOrdernoDetailState[dataIndex]['LINE'] === 'C') ? 
                    ( 
                      <React.Fragment></React.Fragment> 
                    ) 
                    : 
                    (
                      <React.Fragment>                  
                        <input 
                          id={'iOrderDetailInputIndex' + dataIndex + '-' + rowIndex} 
                          type={inputType} 
                          name={'nOrderDetailInputIndex' + dataIndex + '-' + rowIndex}
                          key={dataIndex + '-' + rowIndex + '-' + newOrdernoDetailState[dataIndex]['LINENO'] + '-' + newOrdernoDetailState[dataIndex]['LINE'] + '-' + newOrdernoDetailState[dataIndex]['PARTNO'] + '-' + newOrdernoDetailState[dataIndex]['USER_INPUT_QTY']}
                          defaultValue={newOrdernoDetailState[dataIndex][colName] === null ? '' : newOrdernoDetailState[dataIndex][colName]}
                          maxLength="50"
                          onChange={(e) => {
                              newOrdernoDetailState[dataIndex][colName] = e.target.value.trim()
                              console.log('Orders newOrdernoDetailState[dataIndex][colName]:' + JSON.stringify(newOrdernoDetailState[dataIndex][colName]))                  
                            }
                          } 
                          // onBlur={(e) => {
                          //     console.log('Orders onBlur:' + JSON.stringify(e.target.value))                  
                          //     e.target.focus()
                          //   }
                          // }                 
                        />                                                                           
                        
                      </React.Fragment>
                    )
                  }
                </span>
              )          
            }                   
            else if(colName === 'ORDERQTY'){
              return (
                <span>
                  <button type='button' onClick={(e)=> 
                    {
                      dispatch_deleteRowLineOrdernoDetail(dataIndex)                      
                    } 
                  }>Delete Row</button>
                </span>
              )          
            }
            else if (colName === 'USER_INPUT_QTY'){        
              return (
                <span>              
                  {authreducerState.user.role_name === undefined || 
                    (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ||
                    (newOrdernoDetailState[dataIndex]['LINE'] === 'C') ? 
                    ( 
                      <React.Fragment></React.Fragment> 
                    ) 
                    : 
                    (
                      <React.Fragment>                  
                        <input 
                          id={'iOrderDetailInputIndex' + dataIndex + '-' + rowIndex + '-' + newOrdernoDetailState[dataIndex]['LINENO']} 
                          className={'userInputField'}
                          type={inputType} 
                          name={'nOrderDetailInputIndex' + dataIndex + '-' + rowIndex + '-' + newOrdernoDetailState[dataIndex]['LINENO']} 
                          key={dataIndex + '-' + rowIndex + '-' + newOrdernoDetailState[dataIndex]['LINENO'] + '-' + newOrdernoDetailState[dataIndex]['LINE'] + '-' + newOrdernoDetailState[dataIndex]['PARTNO'] + '-' + newOrdernoDetailState[dataIndex]['USER_INPUT_QTY']}
                          min="0"                 
                          defaultValue={newOrdernoDetailState[dataIndex][colName] === null ? 0 : newOrdernoDetailState[dataIndex][colName]}
                          onChange={(e) => {
                              newOrdernoDetailState[dataIndex][colName] = e.target.value
                              console.log('Orders newOrdernoDetailState[dataIndex][colName]:' + JSON.stringify(newOrdernoDetailState[dataIndex][colName]))                  
                            }
                          }                  
                        />                                                                           
                        
                      </React.Fragment>
                    )
                  }
                </span>
              )
            }
            else{
            
              return (
                <span>  
                  <React.Fragment>              
                  {newOrdernoDetailState[dataIndex][colName]}  
                  </React.Fragment>                                                                                  
                </span>
              )           
            }                   
          }
          else{
            if(colName === 'ORDERQTY'){
              return (
                <span>              
                  { newOrdernoDetailState[dataIndex]['LINE'] === 'C' ? 
                    ( 
                      <React.Fragment></React.Fragment> 
                    ) 
                    : 
                    (
                      <React.Fragment>  
                        {newOrdernoDetailState[dataIndex]['ORDERQTY']}                                                                    
                      </React.Fragment>
                    )
                  }
                </span>
              )          
            }
            else if (colName === 'USER_INPUT_QTY'){        
              return (
                <span>              
                  {authreducerState.user.role_name === undefined || 
                    (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ||
                    (newOrdernoDetailState[dataIndex]['LINE'] === 'C') ? 
                    ( 
                      <React.Fragment>
                        {newOrdernoDetailState[dataIndex]['SHIPPEDQTY']}
                      </React.Fragment> 
                    ) 
                    : 
                    (
                      <React.Fragment>                  
                        <input 
                          id={'iOrderDetailInputIndex' + dataIndex + '-' + rowIndex} 
                          className={'userInputField'}
                          type={inputType} 
                          name={'nOrderDetailInputIndex' + dataIndex + '-' + rowIndex}
                          key={dataIndex + '-' + rowIndex + '-' + newOrdernoDetailState[dataIndex]['LINENO']}
                          min="0"
                          
                          defaultValue={newOrdernoDetailState[dataIndex]['LINE_ACTION'] === 'ADD' ? newOrdernoDetailState[dataIndex]['SHIPPEDQTY'] : newOrdernoDetailState[dataIndex][colName] === null ? 0 : newOrdernoDetailState[dataIndex][colName]}
                          onInput={(e) => {
                            var min = e.target.min
                            var max = newOrdernoDetailState[dataIndex]['ORDERQTY'] 
                            var val = parseInt(e.target.value) || (min - 1); // if input char is not a number the value will be (min - 1) so first condition will be true
                            if (val < min){
                              newOrdernoDetailState[dataIndex][colName] = min
                              e.target.value = min
                            }
                            else if (val > max){
                              if (window.confirm('Please confirm if you want to add a shippedQty > than orderQty')) {
                                newOrdernoDetailState[dataIndex][colName] = e.target.value                                
                              }
                              else{
                                e.target.value = newOrdernoDetailState[dataIndex]['SHIPPEDQTY']
                                newOrdernoDetailState[dataIndex][colName] = newOrdernoDetailState[dataIndex]['SHIPPEDQTY']
                              }
                            }                       
                            else 
                              newOrdernoDetailState[dataIndex][colName] = e.target.value
                          }}                 
                        />                                                                           
                        
                      </React.Fragment>
                    )
                  }
                </span>
              )
            }
            else{
            
              return (
                <span>  
                  <React.Fragment>              
                    {newOrdernoDetailState[dataIndex][colName]}  
                  </React.Fragment>                                                                                  
                </span>
              )           
            }
          }
        }

      }             
    } 
    
    return options;
  }

  const columnsOrdernoDetail = [  
    {
      name: "LINENO",
      label: "LineNo",
      options: columnsOptions_ordernoDetail('LINENO', 'text', true),
    },     
    {
      name: "LINE",
      label: "Line",
      options: columnsOptions_ordernoDetail('LINE', 'text', true),
    },
    {
      name: "PARTNO",
      label: "Partno",
      options: columnsOptions_ordernoDetail('PARTNO', 'text', true),
    },
    {
      name: "THIRD_PARTY_BIN_1",
      label: "BIN",
      options: columnsOptions_ordernoDetail('THIRD_PARTY_BIN_1', 'text', true),
    },    
    {
      name: "ORDERQTY",
      label: "Order Qty",
      options: columnsOptions_ordernoDetail('ORDERQTY', 'number', false),
    },
    {
      name: "USER_INPUT_QTY",
      label: "Shipped Qty",
      options: columnsOptions_ordernoDetail('USER_INPUT_QTY', 'number', false),
    },        
  ]

  // const AddButton = () => (
  //   <Tooltip disableFocusListener title="Add Line">
  //     <IconButton onClick={() => dispatch_addLineOrdernoDetail()}>
  //       <PlaylistAdd />
  //     </IconButton>
  //   </Tooltip>
  // );

  const ClearSelectedCheckboxButton = (selectedRows, displayData, setSelectedRows) => (
    <Tooltip title="Clear Selected Checkboxes">
      <IconButton id="clearPrintSelectedCbId" onClick={ () => {
        setRowsOrdersIndexState([])
        }
      }>Clear Selected Checkboxes</IconButton>
    </Tooltip>
  );

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect( () => {
    if( ordersPrintState !== undefined && Object.keys(ordersPrintState).length > 0 ){
      setPrintBtnClickedState(true);      
    }       
  }, [ordersPrintState]);

  useEffect( () => {
    if( printBtnClickedState !== undefined && printBtnClickedState === true ){
      // handlePrint()
      setPrintBtnClickedState(false);
    }       
  }, [printBtnClickedState, handlePrint]);

  const PrintOrdersPickticketButton = (selectedRows) => (
    <Tooltip title="Print Selected Pickticket">
      <span>
        <IconButton id='printOrdersBtnId' onClick={ () => {
            fetch_OrdernosPrintPicktickets(authreducerState.user, selectedOrdernosState);
            // setSelectedRowsOrdersState(selectedRows)
        }
        }><Print/> Print Selected Picktickets</IconButton>
      </span>
    </Tooltip>
  );

  const PrintButton = () => (
    <Tooltip disableFocusListener title="Print">
      <IconButton onClick={() => dispatch_Print()}>
        <Print />
      </IconButton>
    </Tooltip>
  );

  const HeaderElements = () => (
    <>
      <PrintButton />
    </>
  );

  const optionsOrdernoDetail = {
    filterType: "checkbox",
    selectableRows: 'none',
    responsive: "standard",
    print: false,
    onRowClick: (rowData, rowMeta) => {
      console.log("Orders optionsOrdernoDetail onRowClick rowData:" + JSON.stringify(rowData) + " rowMeta:" + JSON.stringify(rowMeta) + " orderDetailState[rowMeta[dataIndex]]:" + JSON.stringify(orderDetailState[rowMeta['dataIndex']]));
    },
    onChangePage (currentPage) {
      console.log({currentPage});
     
    },
    rowsPerPage: 200,
    customToolbar: () => (<HeaderElements />),
  };  


  const orderDetailSubmitBtn = () => {
    return (
      <button type='button' id='submitOrdernoDetail' onClick={(e)=> 
        {            
          var checkCorePickUpState = (corePickupState.hasOwnProperty('CORE_MD_QTY') || 
            corePickupState.hasOwnProperty('CORE_SM_QTY') ||
            corePickupState.hasOwnProperty('CORE_GOLF_QTY') ||
            corePickupState.hasOwnProperty('CORE_LG_QTY')) 

          if (corePickupAvailableChecked === true)
          {                      
            if(checkCorePickUpState === false) 
            {                        
              if (window.confirm('Please proceed if there are no cores for current customer or cancel to enter cores.')) 
              {                          
                if (window.confirm('Click Ok to submit order or Cancel to not submit order.')) 
                {
                  const noCorePickupState = {}
                  fetch_submitOrdernoDetail(orderDetailState,noCorePickupState) 
                  window.scrollTo({ top: 0, behavior: 'smooth' });                               
                } 
                else 
                {
                  console.log('Cancelled - Order was not saved.');
                }                            
              }
              else 
              {
                console.log('Cancelled - Order was not saved. May have needed to enter cores');
              } 
            }
            else
            {
              if (window.confirm('Click Ok to submit order or Cancel to not submit order.')) 
              {
                if(checkCorePickUpState === true) 
                {
                  corePickupState['DETERMINED_CORE_CUSTID'] = orderDetailHeaderState['DETERMINED_CORE_CUSTID']
                  corePickupState['USERID'] = authreducerState.user.userid
                  
                  if(corePickupState['LOC'] === undefined || corePickupState['LOC'] === '0'){
                    corePickupState['LOC'] = orderDetailHeaderState['ORDERLOC']
                  } 
                }
                console.log('Orders corePickupState submit:' + JSON.stringify(corePickupState) + " Object.keys(corePickupState).length: " + Object.keys(corePickupState).length );

                fetch_submitOrdernoDetail(orderDetailState,corePickupState) 
                window.scrollTo({ top: 0, behavior: 'smooth' });                 
              } 
              else 
              {
                console.log('Cancelled - Order was not saved.');
              }                            
            }                          
                                    
          }
          else
          {
            if (window.confirm('Click Ok to submit order or Cancel to not submit order.')) 
            {
              const noCorePickupState = {}
              fetch_submitOrdernoDetail(orderDetailState,noCorePickupState) 
              window.scrollTo({ top: 0, behavior: 'smooth' });              
            } 
            else 
            {
              console.log('Cancelled - Order was not saved.');
            }                            
          }
          
          
        }
  
      
      }>Submit</button>
    )    
  }

  const getMuiTheme = () =>
  createTheme({
    overrides: {
      MUIDataTableToolbar: {
        actions: {
          display: "flex",
          flex: "initial",
          // move all icons to the right
          "& > span, & > button": {
            order: 99
          },
          // target the custom toolbar icon
          "& > span:last-child, & > button:last-child": {
            order: 1
          },
          // target any icon
          "& > span:nth-child(4), & > button:nth-child(4)": {
            order: 2
          }
        }
      }
    }
  });

  const successfulSubmit = () => {
    try{
      var userInputFieldCollection = document.getElementsByClassName('userInputField');
      for (let i = 0; i < userInputFieldCollection.length; i++) {
        userInputFieldCollection[i].disabled = true; 
        userInputFieldCollection[i].style.pointerEvents = "none"; 
        userInputFieldCollection[i].setAttribute('display', 'hideClass'); 
      }
    }
    catch(err){
      console.log('Orders successfulSubmit err:' + err)
    }

  }

  return (

    <div>
        <div>   
          <div id='ordersTblId' className='landingPageTblClass'>
          
            { orderState !== undefined && orderState !== null ?
                orderState.length === 0 ?
                  <div>
                      <EmptyMuiDataTable title={'No Orders'} />                  
                  </div>
                  : 
                  <div>
                    <div id='ordersTblPrompt'>

                    </div>
                    
                    <MUIDataTable
                        title={"Orders"}
                        data={orderState}
                        columns={columnsOrders}
                        options={optionsOrders}
                    />  
                  </div>

              : ''            
            }

          </div>

          <div id='ordernoTblId' className='detailTblClass'>

            { orderDetailState !== undefined && 
              orderDetailState !== null ?
              orderDetailState.length > 0 ?                
                <div>                                                  
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={
                        <table id='ordernoDetailTblHeader'>
                          <thead>
                            <tr>
                              <th colSpan='4'>Order Detail {orderDetailHeaderState['ORDERNO']}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {orderDetailHeaderState['ORDER_CUSTNO'] !== undefined ? 
                                <React.Fragment>
                                  <td>Customer#:</td>
                                  <td>
                                    {orderDetailHeaderState['ORDER_CUSTNO']}
                                  </td>
                                </React.Fragment>  
                                   
                                :
                                <React.Fragment>
                                  <td></td>
                                  <td></td>
                                </React.Fragment>                                
                              }
                            </tr>
                            <tr>
                              {orderDetailHeaderState['CUST_PO'] !== undefined ? 
                                <React.Fragment>
                                  <td>CustPO:</td>
                                  <td>
                                    {orderDetailHeaderState['CUST_PO']}
                                  </td>
                                </React.Fragment>  
                                   
                                :
                                <React.Fragment>
                                  <td></td>
                                  <td></td>
                                </React.Fragment>                                
                              }
                            </tr>
                            <tr>
                              {orderDetailHeaderState['WRITER'] !== undefined ? 
                                <React.Fragment>
                                  <td>WRITER:</td>
                                  <td>
                                    {orderDetailHeaderState['WRITER']}
                                  </td>
                                </React.Fragment>  
                                   
                                :
                                <React.Fragment>
                                  <td></td>
                                  <td></td>
                                </React.Fragment>                                
                              }
                            </tr>                            
                            <tr>
                              {orderDetailHeaderState['INSTRUCTIONS'] !== undefined ? 
                                <React.Fragment>
                                  <td>Instructions:</td>
                                  <td>
                                    {orderDetailHeaderState['INSTRUCTIONS']}
                                  </td>
                                </React.Fragment>  
                                   
                                :
                                <React.Fragment>
                                  <td></td>
                                  <td></td>
                                </React.Fragment>                                
                              }
                            </tr>                                                          
                            <tr>                            
                              {orderDetailHeaderState['ORDERNO'] !== undefined ? 
                                <React.Fragment>
                                  <td>Shipped To:</td>
                                  <td>
                                    {orderDetailHeaderState['SHIP_TO_NAME']}
                                    <br/>
                                    {orderDetailHeaderState['SHIP_TO_ADDR1']}
                                    <br/>                                    
                                    {orderDetailHeaderState['SHIP_TO_ADDR2']}
                                    {orderDetailHeaderState['SHIP_TO_ADDR2'] === '' ? '' :  <br/>}                                 
                                    {orderDetailHeaderState['SHIP_TO_CITY'] + ', ' + orderDetailHeaderState['SHIP_TO_STATE'] + ' ' + orderDetailHeaderState['SHIP_TO_ZIP']}
                                  </td>   
                                </React.Fragment>
                                : 
                                <React.Fragment>
                                  <td>Orderno: {orderDetailState[0]['ORDERNO']}</td>
                                  <td></td>
                                </React.Fragment> 
                              }
                            </tr>
                          
                          </tbody>
                        </table>
                      }                
                      data={orderDetailState}
                      columns={columnsOrdernoDetail}
                      options={optionsOrdernoDetail}
                    />
                  </ThemeProvider>

                  {/* <button type='button' id='orderAddRow' className={'userInputField'} onClick={()=>{ dispatch_addLineOrdernoDetail()} }>Add Order Row</button> */}

                  {
                    (authreducerState.user.role_name === undefined) ? "" :                    
                      (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" :
                    (orderDetailHeaderState['USER_THIRD_PARTY_PERMISSIONID'] > 1 )
                     ?                                         
                      ''
                     :
                     <div id='corePickupDivId'>
                     <div id='corePickupAvailableId'>
                       Cores Picked Up?
                       <input 
                         id='iCorePickupCb'
                         className={'userInputField'}
                         type='checkbox'
                         name='corePickupCbName'                   
                         checked={corePickupAvailableChecked}
                         onChange={(e) => {
                           if(corePickupAvailableChecked === false){
                             setCorePickupAvailableChecked(true)
                           }
                           else{
                             setCorePickupAvailableChecked(false)
                           }
                           //setCorePickupAvailableChecked( corePickupAvailableChecked = !corePickupAvailableChecked);
                         }}
                         onClick={(e) => {
                           if(corePickupAvailableChecked)
                           {
                             document.getElementById('corePickupTblId').style.display = "none";
                             document.getElementById('corePickupLocTbl').style.display = "none";
                           }
                           else{
                             document.getElementById('corePickupTblId').style.display = "table";
                             document.getElementById('corePickupLocTbl').style.display = "table";
                           }
                         }}
                       />
                     </div>
                     
                     <table id='corePickupLocTbl'>
                           <thead>
                           
                           </thead>
                           <tbody>
                           
                             <tr>
                               <td style={ {fontWeight:'bold', textAlign:'end'} }>Loc:</td>
                               <td>                    
                                 { orderDetailHeaderState['USER_HAS_MULTIPLE_LOCS'] !== undefined && orderDetailHeaderState['USER_HAS_MULTIPLE_LOCS'] === true ?                    
 
                                 <input
                                   id='iCorePickupLoc'
                                   className={'userInputField'}
                                   type='number'
                                   maxLength='3'
                                   min='0'
                                   max='999'
                                   name='corePickupLoc'
                                   defaultValue={corePickupState['LOC'] = orderDetailHeaderState['ORDERLOC']}
                                   onInput={(e) => {
                                     if(corePickupState['LOC'] === undefined || corePickupState['LOC'] === '' || e.target.value === '0'){
                                       corePickupState['LOC'] = orderDetailHeaderState['ORDERLOC']
                                       e.target.value = orderDetailHeaderState['ORDERLOC']
                                     }
                                     else{
                                       var min = e.target.min
                                       var max = e.target.max
                                       var val = parseInt(e.target.value) || (min - 1); // if input char is not a number the value will be (min - 1) so first condition will be true
                                       if (val < min){
                                         corePickupState['LOC'] = min
                                         e.target.value = min
                                       }
                                       else if (val > max){
                                         corePickupState['LOC'] = max 
                                         e.target.value = max 
                                       }                       
                                       else{
                                        corePickupState['LOC'] = e.target.value
                                       }
                                     }                                    
 
                                   }}                                  
                                 />                       
                               :
                                 orderDetailHeaderState['ORDERLOC']
                             }
                           </td>
                         </tr>
                         <tr>
                           <td style={ {fontWeight:'bold', textAlign:'end'} }>Default Order Loc:</td>
                           <td>{orderDetailHeaderState['ORDERLOC']} ({orderDetailHeaderState['LOC_CITY']},{orderDetailHeaderState['LOC_STATE']}) </td>
                         </tr> 
                         <tr>
                           <td style={ {fontWeight:'bold', textAlign:'end'} }>Custno:</td>
                           <td>{orderDetailHeaderState['DETERMINED_CORE_CUSTNO']}</td>
                         </tr>                                                         
                       </tbody>
                     </table> 
 
                     <table id='corePickupTblId'>
                       {/* <caption>Cores Picked up</caption> */}
                       <thead>
                         <tr>
                           <th>Type</th>
                           <th>Pickup Qty</th>                  
                         </tr>
                       </thead>

                           
                       <tbody>                            
                          <tr>
                            <td>
                            BCRSM-CORE (U1's, Small SLA's, Power Sport)                  
                            </td>  
                            <td>
                              <input 
                                id='iCoreSMPickupQty'
                                className={'userInputField'}
                                type='number' 
                                name='nCoreSMPickupQty' 
                                min="0"       
                                max="500"
                                defaultValue={0}                   
                                onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_SM_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_SM_QTY'] = e.target.value   
                                    }                                           
                                  }
                                }
                              />                      
                            </td>  
                          </tr>
                          <tr>
                            <td>
                            BCRMD-CORE (Auto/Marine <span style={ {textDecoration:'underline'} }>not</span> group 31)                
                            </td>
                            <td>
                              <input 
                                id='iCoreMDPickupQty'
                                className={'userInputField'}
                                type='number' 
                                name='nCoreMDPickupQty'                      
                                min="0"       
                                max="500"
                                defaultValue={0}               
                                onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key  
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_MD_QTY']
                                      console.log('iCoreEAPickupQty CORE_MD_QTY deleted corePickupState' + JSON.stringify(corePickupState))
                                    }
                                    else{
                                      corePickupState['CORE_MD_QTY'] = e.target.value   
                                    }                                      
                                    
                                  }
                                }
                              />                      
                            </td>                     
                          </tr> 
                          <tr>
                            <td>
                            BCRLG-CORE (4D, 8D & <span style={ {textDecoration:'underline'} }>All</span> group 31)                  
                            </td>
                            <td>
                              <input 
                                id='iCoreLGPickupQty'
                                className={'userInputField'}
                                type='number' 
                                name='nCoreLGPickupQty'                      
                                min="0"       
                                max="500"
                                defaultValue={0}               
                                onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_LG_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_LG_QTY'] = e.target.value   
                                    }
                                    
                                    
                                  }
                                }
                              />                      
                            </td>                     
                          </tr>   
                          <tr>
                            <td>
                            BCRCOREGOLF-EA (Golf)                    
                            </td>  
                            <td>
                              <input 
                                id='iCoreGolfPickupQty'
                                className={'userInputField'}
                                type='number' 
                                name='nCoreGolfPickupQty'                      
                                min="0"       
                                max="500"
                                defaultValue={0}                   
                                onChange={(e) => {
                                    //note corePickupState key matches views.py submitOrdernoDetail() coreDict key 
                                    if(e.target.value === '0'){
                                      delete corePickupState['CORE_GOLF_QTY']
                                    }
                                    else{
                                      corePickupState['CORE_GOLF_QTY'] = e.target.value   
                                    }                                         
                                  }
                                }
                              />                      
                            </td>  
                          </tr>                                                                                                      
                        </tbody>   
                       {
                       /* { orderDetailHeaderState['CORETYPE_CUSTOMER_RESTRICTION'] !== undefined && orderDetailHeaderState['CORETYPE_CUSTOMER_RESTRICTION'] === true ?
                           <tbody>
                           </tbody>
                         :                                              
                       } */}
 
                     </table>
                   </div>                                        
                  }


                  <button type='button' id='backToOrders' onClick={()=>{
                    window.location.href='/'
                  }}>Back</button>

                  { orderServerResponseState !== undefined && orderServerResponseState !== null && 
                      Object.keys(orderServerResponseState).length > 0 &&
                        orderServerResponseState['SUCCESSFUL_UPDATES'] !== '' ? 
                            <React.Fragment>
                              {fetch_landingPageStates(authreducerState.user)}
                            </React.Fragment>

                            // <div>
                            //   {successfulSubmit()}                              
                            // </div>
                                                                                                                                                       
                    :
                    (authreducerState.user.role_name === undefined) ? "" :                    
                      (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" :
                    (orderDetailHeaderState['USER_THIRD_PARTY_PERMISSIONID'] > 1 )
                      ?     
                        ''
                      :
                      orderDetailSubmitBtn()
                  }

     
                </div>


                : ''
              : ''
          
            }

          </div>


        </div>
    </div>

  );
}



const mapStateToProps = (state) => {

 return {
  orderState: state.ordersTransferReducer['items_fetchOrders'],
  orderDetailState: state.ordersTransferReducer['items_fetchOrdernoDetail'],
  orderDetailHeaderState: state.ordersTransferReducer['items_fetchOrdernoDetailHeader'], 
  corePickupState: state.ordersTransferReducer['items_fetchCorePickup'],  
  authreducerState: state.authreducer,
  orderServerResponseState: state.statusUpdateReducer['orderServerResponse'],
  ordersPrintState: state.ordersTransferReducer['items_fetchOrdersPrint']
 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_landingPageStates: (user) => {
      dispatch(fetchOrders(user));
      dispatch(fetchTransfers(user));
      dispatch(fetchCustomers(user));
      dispatch(fetchInventory(user));
    },       
    fetch_orders: (user) => {
      dispatch(fetchOrders(user));
    },
    fetch_ordernoDetail: (user, orderno) => {
      dispatch(fetchOrdernoDetail(user, orderno));
    }, 
    fetch_submitOrdernoDetail: (orderDetailState,corePickupState) => {
      dispatch(fetchSubmitOrdernoDetail(orderDetailState,corePickupState));
    },
    dispatch_addLineOrdernoDetail: () => {
      dispatch(addLineOrdernoDetail());
    },
    dispatch_Print: () => {
      dispatch(PrintOrder());
    },    
    dispatch_deleteRowLineOrdernoDetail: (dataIndex) => {
      dispatch(deleteRowLineOrdernoDetail(dataIndex));
    },
    fetch_OrdernosPrintPicktickets: (user, selectedOrdernos) => {
      dispatch(fetchOrdernosPrintPicktickets(user, selectedOrdernos));
    }           
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Orders);